import React, { useContext, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Container, Row } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-scroll';
import PortfolioContext from '../../context/context';

const Header = () => {
  const { hero } = useContext(PortfolioContext);
  const { subtitle } = hero;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="hero" className="jumbotron">
      <Container>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={500} distance="30px">
          <h1 className="hero-title">
            {'Hi, my name is '}
            <motion.span
              className="text-color-main name"
              initial="hidden"
              animate="animate"
              transition={{
                staggerChildren: 0.04,
                delayChildren: 1,
              }}
            >
              {'Khaled Osama'.split('').map((letter) => (
                <motion.span
                  variants={{
                    hidden: {
                      opacity: 0,
                    },
                    animate: {
                      opacity: 1,
                    },
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.span>
            <br />
            {subtitle || "I'm a software engineer."}
          </h1>
        </Fade>
        <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
          <Row className="hero-cta">
            <span className="cta-btn cta-btn--hero">
              <Link to="about" smooth duration={1000}>
                Know more
              </Link>
            </span>
            <span className="cta-btn cta-btn--hero">
              <Link to="experience" smooth duration={1000}>
                Experience
              </Link>
            </span>
            <span className="cta-btn cta-btn--hero">
              <Link to="contact" smooth duration={1000}>
                Social links
              </Link>
            </span>
          </Row>
        </Fade>
      </Container>
    </section>
  );
};

export default Header;
